import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectProjeSorumlusu,
  selectProjeUygulamaSorumlusu,
  updateBaslikDefaults,
} from '../../../../redux/baslikSlice';

export default function ProjeSorumlusuSection() {
  const dispatch = useDispatch();
  const projeSorumlusu = useSelector(selectProjeSorumlusu);
  const uygulamaSorumlusu = useSelector(selectProjeUygulamaSorumlusu);

  const handleChange = (section, field, value) => {
    dispatch(updateBaslikDefaults({ section, changes: { [field]: value } }));
  };

  const fields = [
    { key: 'adiSoyadi', label: 'Adi Soyadi' },
    { key: 'odaNo', label: 'Oda No' },
    { key: 'diplomaNo', label: 'Diploma No' },
    { key: 'vergiSicilNo', label: 'Vergi Sicil No' },
    { key: 'vergiDairesi', label: 'Vergi Dairesi' },
  ];

  return (
    <div className="detail-section-content">
      <div className="detail-col-title">Proje Sorumlusu</div>
      {fields.map(({ key, label }) => (
        <div className="detail-field" key={`ps-${key}`}>
          <label>{label}</label>
          <input
            type="text"
            value={projeSorumlusu[key]}
            onChange={e => handleChange('projeSorumlusu', key, e.target.value)}
          />
        </div>
      ))}

      <div className="detail-col-title" style={{ marginTop: 8 }}>Proje Uygulama Sorumlusu</div>
      {fields.map(({ key, label }) => (
        <div className="detail-field" key={`us-${key}`}>
          <label>{label}</label>
          <input
            type="text"
            value={uygulamaSorumlusu[key]}
            onChange={e => handleChange('projeUygulamaSorumlusu', key, e.target.value)}
          />
        </div>
      ))}
    </div>
  );
}
